import { FormatCurrencyOptions } from "@/hooks/useConfig/types";
import { isFinite, round } from "lodash";

/**
 * Helper function to format a number value or return "N/A" if it's not a valid number
 */
export const formatUnitValue = (value: number | null | undefined): string => {
  if (!isFinite(value) || value === 0) {
    return "0";
  }
  const roundedValue = round(value as number, 0);
  return roundedValue.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

/**
 * Helper function to format a number value or return "N/A" if it's not a valid number
 */
export const formatAdStockValue = (value: number | null | undefined): string => {
  if (!isFinite(value) || value === 0) {
    return "N/A";
  }
  return `${round(value as number, 1)}`;
};

/**
 * Helper function to format a currency value or return "N/A" if it's not a valid number
 * potentially intercepting divide by 0 errors or other strange number behaviours
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Infinity
 */
export const formatCurrencyValue = (
  value: number | null | undefined,
  formatCurrency: (val: number, options?: FormatCurrencyOptions) => string,
  options?: FormatCurrencyOptions
): string => {
  if (!isFinite(value)) {
    return "N/A";
  }
  return formatCurrency(value as number, options);
};

/**
 * Helper function to format a percentage value or return "N/A" if it's not a valid number
 */
export const formatPercentValue = (value: number | null | undefined, decimals = 2): string => {
  if (!isFinite(value) || value === 0) {
    return "0%";
  }
  return `${round(value as number, decimals)}%`;
};
